import "regenerator-runtime/runtime"
import React, { Fragment, useEffect } from "react"
import { useHomePageSanityData } from "../graphql/queries/home-page-queries"
import LandingSection from "../components/Sections/landingSection/LandingSection"
import NewLandingSection from "../components/Sections/landingSection/newLandingSection"
import WhatWeOfferSection from "../components/Sections/WhatWeOfferSection/WhatWeOfferSection"
import Seo from "../components/seo"
import Awards from "../components/Awards/Awards"
import NewOurAIProducts from "../components/Sections/NewOurAIProductsSection/NewOurAIProducts"
import SolutionsMenu from "../components/SolutionsMenu/SolutionsMenu"
import MapComponent from "../components/MapComponent/MapComponent"
import UniquevaluePropositions from "../components/UniqueValuePropositions/UniquevaluePropositions"
import NewLayout from "../components/layout/NewLayout"
import "../styles/fullPageOverride.css"
import FAQSection from "../components/Sections/FAQSection/FAQSection"
import Carousel from "../components/Sections/CarouselSection/carousel"
import ProvenResultsSection from "../components/Sections/ProvenResultsSection/ProvenResultsSection"
import JourneyToROISection from "../components/Sections/JourneyToROISection/JourneyToROISection"
import LastSection from "../components/Sections/LastSection/LastSection"
import "../styles/healthcare-industry.css"
import "../styles/ai-for-retail.css"
import ContentSection from "../components/Sections/ContentSection/ContentSection"
import NewCarousel from "../components/Sections/CarouselSection/NewCarousel"
import { Link } from "gatsby"
import EndingSection from "../components/Sections/LastSection/EndingSection"

const Indexpage = ({ location }) => {
  const { allSanityPage } = useHomePageSanityData()

  // useEffect(() => {
  //   const params = new URLSearchParams(location.search)
  //   const scrollTo = params.get("section")

  //   if (scrollTo) {
  //     const element = document.getElementById(scrollTo)
  //     const header = document.getElementById("header-wrapper")
  //     if (element) {
  //       const targetPosition =
  //         element.getBoundingClientRect().top + window.scrollY
  //       const scrollToPosition = targetPosition - header?.offsetHeight
  //       window.scrollTo({ top: scrollToPosition, behavior: "smooth" })
  //     }
  //   }
  // }, [location])

  return (
    <div className="indexPage">
      <NewLayout location={location}>
        {allSanityPage.nodes[0]?.slide?.map((data, index) => (
          <Fragment key={index}>
            {index === 0 && (
              <>
                <NewLandingSection />
                {/* <LandingSection sectionData={data} /> */}
              </>
            )}
            {data?.slideClassName === "what-we-offer-section" && (
              <WhatWeOfferSection data={data} />
            )}

            {data?.slideClassName === "meaningful-outcomes-section" && (
              <ContentSection classname={data?.slideClassName} data={data} />
            )}
            {data?.slideClassName === "accelerators-section" && (
              <ContentSection classname={data?.slideClassName} data={data} />
            )}
            {data?.carousel?.length > 0 && (
              <NewCarousel
                data={data}
                location={location}
                defaultOption="Healthcare"
              />
            )}

            {/* {data?.uniqueValues?.length > 0 && (
              <UniquevaluePropositions data={data} />
            )}

            {data?.solutionsMenu?.length > 0 && (
              <SolutionsMenu data={data?.solutionsMenu} />
            )}

            {data?.AIAccelerators?.length > 0 && (
              <>
                <NewOurAIProducts data={data} />
              </>
            )}

            {data?.carousel?.length > 0 && <Carousel carouselData={data} />}

            {data?.Awards?.length > 0 && (
              <div>
                <Awards
                  data={data?.Awards}
                  title={"Awards & Recognition"}
                  subTitle={""}
                  isHomePage={true}
                />
              </div>
            )}

            {data?.techolutionStats?.length > 0 && <MapComponent data={data} />}

            {data?.provenResults?.length > 0 && (
              <ProvenResultsSection data={data} />
            )}
            {data?.slide_name?.includes("Your Journey") && (
              <JourneyToROISection data={data} />
            )}
            {data?.slide_name?.includes("FAQs") && <FAQSection data={data} />}
            {data?.slide_name?.includes("last slide") && (
              <LastSection data={data} />
            )} */}
          </Fragment>
        ))}
        <EndingSection />
      </NewLayout>
    </div>
  )
}

export const Head = () => {
  let second = `
{
      "@context": "https://schema.org/", 
      "@type": "FAQPage", 
      "mainEntity": [{
        "@type": "Question", 
        "name": "What Is Techolution?",
        "acceptedAnswer": { 
          "@type": "Answer",
          "text": "Techolution is a global AI consulting company specializing in digital transformation, cloud services and artificial intelligence. We help deploy and scale custom-AI solutions making enterprises future-ready with Governed, Guided and Controlled AI."
        } 
      },{
        "@type": "Question", 
        "name": "Which Industries Does Techolution Cater To?",
        "acceptedAnswer": { 
          "@type": "Answer",
          "text": "We serve various industries including Healthcare, Retail, Finance, Manufacturing and the Government."
        }  
     
},{
"@type": "Question",
"name": "What Type Of AI Solutions Does Techolution Provide?",
"acceptedAnswer": {
"@type": "Answer",
"text": "Techolution offers AI solutions such as Conversational AI, Customer Service AI, Legacy Code Modernization, Inventory and Quality Control AI and AI for Healthcare."
}

},{
"@type": "Question",
"name": "How Can AI Improve My Business Operations?",
"acceptedAnswer": {
"@type": "Answer",
"text": "AI can reduce manual labor, automate tasks, provide deep insights, enhance customer experience and improve decision-making."
}


      }]
  }
`
  let third = `
       {         
          "@context": "https://schema.org/",         
          "@type": "WebPage",         
          "@id": "#WebPage",         
          "url": "https://www.techolution.com/",          
          "name": "Techolution Homepage"
        }
          `
  return (
    <Seo
      title="Top AI Consulting Firm | Enterprise AI Consulting Services"
      description="Techolution is an AI Consulting firm offering AI consulting services for enterprises. Start scaling with our production ready, and enterprise-grade custom AI solutions."
      scriptContent={[second, third]}
    />
  )
}

export default Indexpage
